import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import { Form, Input, Button, Icon, Alert, Spin } from 'antd';

export default class LoginForm extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.submitHandler(values.userName, values.password);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { loginFailed, loading, email } = this.props;

        return (
            <Form onSubmit={this.handleSubmit} className="login-form" style={styles.form}>
                { loginFailed ? <Alert message="E-post/lösenord kunde inte verifieras" type="error" showIcon /> : null }
                <Form.Item>
                    {getFieldDecorator('userName', {
                        rules: [{ required: true, message: 'E-post sakans!' }],
                        initialValue: email
                    })(
                        <Input prefix={<Icon type="user" style={styles.input} />} placeholder="E-post" />
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: 'Lösenord saknas!' }],
                    })(
                        <Input prefix={<Icon type="lock" style={styles.input} />} type="password" placeholder="Lösenord" />
                    )}
                </Form.Item>
                <Form.Item>
                    <NavLink to="/auth/reset" style={{ marginRight: '10px' }}>Återställ lösenord</NavLink>
                    <NavLink to="/auth/register">Registrera konto</NavLink>
                    <Spin spinning={loading}>
                        <Button type="primary" block htmlType="submit" className="login-form-button">
                            Logga in
                        </Button>
                    </Spin>
                    
                </Form.Item>
            </Form>
        );
    };
}

const styles = {
    input: { color: 'rgba(0,0,0,.25)' }
};


// WEBPACK FOOTER //
// ./src/screens/auth/components/login/Form.js